const TEMPLATE_TYPES = {
  BOOLEAN: 0,
  INTEGER: 1,
  TEXT: 2,
  SELECTOR: 3,
};

const TEMPLATE_TYPES_LIST = [
  // {
  //   id: TEMPLATE_TYPES.BOOLEAN,
  //   caption: 'Boolean',
  // },
  {
    id: TEMPLATE_TYPES.INTEGER,
    caption: 'Integer',
  },
  {
    id: TEMPLATE_TYPES.TEXT,
    caption: 'Text',
  },
  {
    id: TEMPLATE_TYPES.SELECTOR,
    caption: 'Selector',
  },
];

export default {
  TEMPLATE_TYPES,
  TEMPLATE_TYPES_LIST,
};
